import React from 'react';

const canUseDOM = !!(typeof window !== 'undefined' && window.document);

const withDOM = (WrappedComponent) => (props) => {
    return canUseDOM ? <WrappedComponent {...props} /> : <div />;
};

export default withDOM;
